<div class="image-content aspect-ratio-box-3-2 p-0">
  <div *ngIf="!!backgroundImage && !vimeoId" class="image-content-inner content-padding position-absolute w-100 h-100"
       [style.background-image]="backgroundImage ? safeStyle('url(' + backgroundImage + ')') : ''">
  </div>
  <div class="video" *ngIf="vimeoId">
    <iframe scrolling="no" class="cover-image-background embed-responsive-item video" [style.background-url]="safeStyle('url(' + backgroundImage + ')')" [src]="'https://player.vimeo.com/video/' + vimeoId + '?background=1&autoplay=1&loop=1&byline=0&title=0&dnt=1' | html:'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen muted allowtransparency="true" title="Home Page Video" aria-label="Home Page Video"></iframe>
  </div>
  <div class="container content-padding position-absolute w-100 h-100">
    <div class="position-relative w-100 h-100">
      <ng-content ></ng-content>
    </div>
  </div>
</div>
